module.exports = __webpack_public_path__ + "static/media/section2.5f83cc2c.jpg";